import React, { Component } from "react"

import Layout from "../components/Layout/layout"
import SEO from "../components/seo"

class ContactPage extends Component {
  render() {
    let contactData = this.props.data.allContactJson.nodes[0]
    return (
      <Layout page={"contact"}>
        <SEO title="Contact Us" description="Contact us at skyink to schedule your Tattoo appointment ASAP." />
        <h1 className="title">{contactData.title}</h1>
        <div className="text">
          We would love to hear from you. Drop us a line.
        </div>
        <div className="contact-grid-container">
          <a
            className="contact-grid-item"
            href={`mailto:${contactData.email}?subject=Hello Skyink!`}
          >
            <img
              src={contactData.email_icon}
              alt="Email"
              className="contact-icon"
            />
            <span style={{ display: "block", marginTop: "2em" }}>
              {contactData.email}
            </span>
          </a>
          <a className="contact-grid-item" href={`tel:${contactData.email}`}>
            <img
              src={contactData.phone_icon}
              alt="Phone"
              className="contact-icon"
            />
            <span style={{ display: "block", marginTop: "2em" }}>
              {contactData.phone}
            </span>
          </a>
          <a
            className="contact-grid-item"
            target="_blank"
            rel="noopener noreferrer"
            href={`https://www.facebook.com/${contactData.facebook}`}
          >
            <img
              src={contactData.facebook_icon}
              alt="Facebook"
              className="contact-icon"
            />
            <span style={{ display: "block", marginTop: "2em" }}>
              {contactData.facebook}
            </span>
          </a>
        </div>
        <a className="text" rel="noopener noreferrer nofollow" href="https://www.google.com/maps/@30.0880474,31.3358606,16z" target="_blank" style={{ display: 'block', textAlign: 'center', textDecoration: 'none', marginTop: '2em' }}>Based in Merghany, Cairo</a>
      </Layout>
    )
  }
}
export default ContactPage

export const query = graphql`
  query {
    allContactJson {
      nodes {
        id
        title
        description
        text
        email
        phone
        facebook
        email_icon
        phone_icon
        facebook_icon
      }
    }
  }
`
